// extracted by mini-css-extract-plugin
export default {"searchbar":"Searchbar_searchbar__N8pOn","title":"Searchbar_title__HArdc"};